import { render, staticRenderFns } from "./ProgramacionIndex.vue?vue&type=template&id=742a345b"
import script from "./ProgramacionIndex.vue?vue&type=script&lang=js"
export * from "./ProgramacionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports